import { render, staticRenderFns } from "./license.vue?vue&type=template&id=e51d6bbc&scoped=true"
import script from "./license.vue?vue&type=script&lang=ts"
export * from "./license.vue?vue&type=script&lang=ts"
import style0 from "./license.vue?vue&type=style&index=0&id=e51d6bbc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51d6bbc",
  null
  
)

export default component.exports